import Dashboard from './dashboard/dashboard'
import Crash from './crash'
import { crashResultReducer } from './crash/duck/crashResult.duck'
import { crashBetReducer } from './crash/duck/crashBet.duck'
import { crashSignalReducer } from './crash/duck/crashSignal.duck'
import { crashLogReducer } from './crash/duck/crashLog.duck'
import { crashPromptReducer } from './crash/duck/crashPrompt.duck'
import { botOrchestratorReducer } from './crash/duck/botOrchestrator.duck'

// Reducers do projeto
export const reducers = {
    crashResult: crashResultReducer,
    crashBet: crashBetReducer,
    crashSignal: crashSignalReducer,
    crashLog: crashLogReducer,
    crashPrompt: crashPromptReducer,
    botOrchestrator: botOrchestratorReducer
}

// Rotas do projeto
export const routes = [
    { exact: true, path: '/', component: Dashboard },
    { exact: true, path: '/crash', component: Crash },
]

// Menu do projeto
export const menu = {
    '/': { title: 'Dashboard', icon: 'dashboard' },
    '/crash': { title: 'Crash', icon: 'play', fixed: true },
    // 'profiles': {
    //     title: 'Perfis', icon: 'users',
        //Exemplo de menu cascateado
        // children: {
        //     '/permissions': { title: 'Permissões', icon: 'user' },
        // }
    // }
}